import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/LosAngelesValueWorksheet/derivedFromMeasurementsConfig';
import getMeasuredUsingConfig from 'Components/Worksheets/LosAngelesValueWorksheet/measuredUsingConfig';
import { getConfig as getMoistureContentConfig } from 'Components/Worksheets/MoistureContentWorksheet/BsEnIso/Config';
import qestIds from 'Components/Worksheets/QestIds';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Preparation.DryingTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Preparation.PassingMassIntermediateSieve`]: { format: { nearest: 0.1 } },
      ...getMoistureContentConfig(`${prefix}.Preparation.WashedCoarsePortion.MeasuredConstantDryMass`),
      ...getMoistureContentConfig(`${prefix}.Preparation.WashedFinePortion.MeasuredConstantDryMass`),
      [`${prefix}.Measurements.NoOfBalls`]: { format: { nearest: 1 } },
      [`${prefix}.Measurements.NoOfRevolutions`]: { format: { nearest: 1 } },
      ...getMoistureContentConfig(`${prefix}.Measurements.WashedRecoveredRetainedAggregate.MeasuredConstantDryMass`),
      ...getMoistureContentConfig(
        `${prefix}.Measurements.CoarsePortionRecoveredRetainedAggregate.MeasuredConstantDryMass`
      ),
      ...getMoistureContentConfig(
        `${prefix}.Measurements.FinePortionRecoveredRetainedAggregate.MeasuredConstantDryMass`
      ),
      [`${prefix}.Results.LosAngelesValue`]: { format: { nearest: 1 } },
      [`${prefix}.Results.LosAngelesValue_31_5`]: { format: { nearest: 1 } },
    },
    getLabelConfig(prefix),
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Preparation.Balance`]: { defaultReadability: 1, defaultUom: 'g' },
      [`${prefix}.Preparation.WashedCoarsePortion.MeasuredConstantDryMass.Equipment.DryMassBalance`]: {
        defaultReadability: 1,
        defaultUom: 'g',
      },
      [`${prefix}.Preparation.WashedFinePortion.MeasuredConstantDryMass.Equipment.DryMassBalance`]: {
        defaultReadability: 1,
        defaultUom: 'g',
      },

      [`${prefix}.Measurements.Balance`]: { defaultReadability: 1, defaultUom: 'g' },
      [`${prefix}.Measurements.WashedRecoveredRetainedAggregate.MeasuredConstantDryMass.Equipment.DryMassBalance`]: {
        defaultReadability: 1,
        defaultUom: 'g',
      },
      [`${prefix}.Measurements.CoarsePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.Equipment.DryMassBalance`]:
        {
          defaultReadability: 1,
          defaultUom: 'g',
        },
      [`${prefix}.Measurements.FinePortionRecoveredRetainedAggregate.MeasuredConstantDryMass.Equipment.DryMassBalance`]:
        {
          defaultReadability: 1,
          defaultUom: 'g',
        },
    }
  );

export { getConfig };

export default {
  [qestIds.losAngelesValue.BS_EN_1097_2_Clause_5.rev2020]: getConfig,
};
